import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
//import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#E2782F', // #E53935
          accent: '#ff5252', // #3F51B5
          error: '#ff1744', // #3F51B5
          font: '#ffffff', // #3F51B5
          fontlight: '#000000', // #3F51B5
        },
      },
    },
  });
// export default new Vuetify();
